export default {
    title: 'Couriers',
    addCourier: 'Courier',
    table: {
        columns: {
            name: 'Name',
            phoneNumber: 'Phone number',
            email: 'E-mail',
        },
        tooltips: {
            notVerified: 'Courier has not yet been confirmed by the system',
            resetPassword: 'Change password',
        },
    },
    form: {
        title: 'New courier',
        fields: {
            firstName: {
                label: 'First name',
                placeholder: 'John',
            },
            middleName: {
                label: 'Last name',
                placeholder: 'Smith',
            },
            familyName: {
                label: 'Middle name (optional)',
                placeholder: '',
            },
            email: {
                label: 'E-mail',
                placeholder: 'example@gmail.com',
            },
            phoneNumber: {
                label: 'Phone number',
            },
            password: {
                label: 'Password',
            },
        },
        require: 'This field is required',
        submitButton: 'Add',
        messages: {
            success: 'Courier created',
        },
    },
    resetPasswordForm: {
        title: 'New password',
        hint:
            'The password is shown in plain text on purpose: you have to pass it to the courier. ' +
            'There will be no way to look it up after saving.',
        generate: 'Generate',
        submitButton: 'Save',
        fields: {
            password: {
                label: 'Password',
            },
        },
        validation: {
            require: 'This field is required',
            length: 'From 8 to 64 characters',
            pattern: 'Both latin letters and digits are required',
        },
        messages: {
            success: 'The courier password has been updated',
        },
    },
};
